import * as z from "zod/v4";

export const textConciergeAnalytics = {
  name: "textConciergeAnalytics" as const,
  input: z.object({ start: z.date(), end: z.date() }),

  output: z.object({
    outboundMessages: z.number(),
    uniqueRecipients: z.number(),
    customerReplies: z.number(),
    flaggedConversations: z.number(),
    timeSeries: z.array(
      z.object({ date: z.string(), outbound: z.number(), replies: z.number() }),
    ),
  }),
};
